import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Organization Summary Config"})
export default class OrganizationSummaryConfig {

	@Input({type: InputType.CHECKBOX, title: "Show Organization Logo"})
	public showLogo: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Child Organization Links"})
	public showChildren: boolean;

	@Input({type: InputType.UNIT, title: "Logo Height"})
	public logoHeight?: string;

	@Input({type: InputType.UNIT, title: "Logo Width"})
	public logoWidth?: string;

}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/summary/OrganizationSummaryConfig.ts